import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { forwardRef } from 'react';
// @mui
import { Box, Divider, IconButton, Stack, Typography } from '@mui/material';

// ----------------------------------------------------------------------
import { t } from 'i18next';
import { ArrowBackIos, ArrowForwardIos, Close } from '@mui/icons-material';
import { useNavigate } from 'react-router';
import T from 'src/basic-components/text';
import useLocales from 'src/hooks/useLocales';

const Page = forwardRef(
  (
    {
      as = 'body2',
      hideBorder = false,
      backUrl,
      title,
      subTitle,
      sx,
      variant = 'elevation',
      children,
      elevation = 1,
      Control,
      meta,
      breadcrumbs,
      hideAppbar = false,
      ...props
    },
    ref
  ) => {
    const navigate = useNavigate();
    const { isRTL } = useLocales();

    return (
      <Box sx={{ p: 1 }}>
        <Helmet>
          {<title>{`${t(title)} | ${t('app-name')}`}</title>}
          {meta}
        </Helmet>

        <Stack flex direction="column" gap={1} justifyContent="start" alignItems="start">
          {!hideAppbar && (title || Control) && (
            <Box sx={{ width: props.width || '100%' }}>
              <Stack
                flex
                flexDirection="row"
                gap={1}
                alignItems="center"
                alignContent="center"
                justifyContent="space-between"
              >
                <Stack flex flexDirection="row" gap={1} alignItems="center" alignContent="center">
                  {typeof backUrl == typeof '' && (
                    <IconButton size="small" color={props.color} onClick={() => navigate(backUrl)}>
                      {isRTL() ? <ArrowForwardIos /> : <ArrowBackIos />}
                    </IconButton>
                  )}
                  {typeof backUrl == 'function' && (
                    <IconButton size="small" color={props.color} onClick={() => backUrl()}>
                      <Close />
                    </IconButton>
                  )}
                  <Stack
                    flex
                    flexDirection="column"
                    gap={0}
                    alignItems="start"
                    justifyContent="center"
                    justifyItems="center"
                    sx={{ px: 1 }}
                  >
                    <T variant={as} {...props}>
                      {title}
                    </T>
                    {subTitle && (
                      <Typography fontSize="small" sx={{ mt: 1, color: 'text.secondary' }}>
                        {subTitle}
                      </Typography>
                    )}
                    {breadcrumbs}
                  </Stack>
                </Stack>

                <Box sx={{ mx: 1 }}>{Control}</Box>
              </Stack>
              {!hideBorder && <Divider sx={{ mt: 1 }} />}
            </Box>
          )}
          <Box sx={{ width: '100%' }}>{children}</Box>
        </Stack>
      </Box>
    );
  }
);

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  meta: PropTypes.node,
};

export default Page;
